// Anita Week 5 / Day 2 — Надёжный источник / Reliable Source. Grade-3 with
// source-score table, 1/3 and 1/4 of 48, and print-ready 3-basket classify.

const day2 = {
  id: 'day-2',
  studentId: 'anita',
  weekId: 'week-5',
  dayId: 'day-2',
  status: 'active',
  title: 'Надёжный источник / Reliable Source',
  shortTitle: 'Надёжный источник / Reliable Source',
  theme: 'Анита учится отличать надёжный источник от ненадёжного по автору, дате и доказательству. / Anita learns to tell a reliable source by author, date and evidence.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'information-literacy', 'sources', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни говорит: надёжный источник — тот, у которого есть автор, дата и доказательство. / Nimny says: a reliable source has an author, date and evidence.',
  goals: [
    'Считать баллы источников по критериям автор / дата / доказательство. / Score sources.',
    'Работать с дробями 1/3 и 1/4 от 48. / Fractions of 48.',
    'Сортировать карточки в 3 корзины: доверять, проверить, не использовать. / Classify into 3 baskets.',
    'Найти сумму и средний рейтинг источников. / Sum + average.',
    'Написать простые русские слова темы. / Write theme words.'
  ],
  vocabulary: [
    { term: 'источник / source', definition: 'откуда пришла информация. / where information comes from.' },
    { term: 'автор / author', definition: 'кто написал. / who wrote it.' },
    { term: 'дата / date', definition: 'когда написано. / when it was written.' },
    { term: 'правда / truth', definition: 'что можно доказать. / provable.' },
    { term: 'проверить / to check', definition: 'убедиться. / to verify.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова источника / Source Words',
      prompt: 'Прочитай по-русски:\nисточник\nавтор\nдата\nправда\nпроверить',
      ruPrimaryText: 'Прочитай 5 слов источника.', enHelpText: 'Read 5 source words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\nАвтор говорит, кто это написал.\nДата говорит, когда это написано.\nДоказательство помогает поверить.\nЕсли всего этого нет, источник не самый надёжный.',
      ruPrimaryText: 'Прочитай 4 фразы про надёжный источник.',
      enHelpText: 'Author, date, evidence make a source reliable.',
      answer: 'Попытка чтения.' },
    { id: 'math-source-score', type: 'text', title: 'Задание 3 — Баллы источника / Source Scores',
      prompt: 'В таблице 5 источников. Баллы: автор — 3, дата — 2, доказательство — 4.\nИсточник A имеет автора и доказательство.\nИсточник B имеет дату и доказательство.\n\nОтветь:\n1. Баллы A?\n2. Баллы B?\n3. У кого больше и на сколько?',
      ruPrimaryText: 'Сложи баллы двух источников и сравни.',
      enHelpText: 'Sum criterion scores; compare.',
      answer: '1) A = 3 + 4 = 7. 2) B = 2 + 4 = 6. 3) A больше на 7 − 6 = 1.' },
    { id: 'math-check-48', type: 'text', title: 'Задание 4 — Проверка 48 источников / 48 Sources',
      prompt: 'Анита проверила 48 источников.\n1/4 — старые.\n1/3 — полезные.\nОстальные — проверить ещё раз.\n\nОтветь:\n1. Сколько старых?\n2. Сколько полезных?\n3. Сколько нужно проверить?',
      ruPrimaryText: 'Дроби 1/4 и 1/3 от 48 и остаток.',
      enHelpText: 'Find 1/4 and 1/3 of 48; subtract.',
      answer: '1) 48 ÷ 4 = 12. 2) 48 ÷ 3 = 16. 3) 48 − 12 − 16 = 20.' },
    { id: 'math-time-check', type: 'text', title: 'Задание 5 — Время проверки / Check Time',
      prompt: 'Проверка одного источника — 5 минут. Анита проверила 7 источников и отдыхала 10 минут.\n\nОтветь:\n1. Сколько минут проверяла?\n2. Сколько времени всего?',
      ruPrimaryText: 'Умножение времени + отдых.',
      enHelpText: 'Multiply 5 × 7, then add 10.',
      answer: '1) 5 × 7 = 35. 2) 35 + 10 = 45 минут.' },
    { id: 'math-avg-rating', type: 'text', title: 'Задание 6 — Средний рейтинг / Average Rating',
      prompt: 'Рейтинги источников: 6, 8, 7, 9.\n\nОтветь:\n1. Сумма?\n2. Средний рейтинг (сумма ÷ 4)?',
      ruPrimaryText: 'Сумма 4 чисел + деление на 4.',
      enHelpText: 'Sum then divide by 4.',
      answer: '1) 6 + 8 + 7 + 9 = 30. 2) 30 ÷ 4 = 7.5.' },
    { id: 'logic-classify-sources', type: 'text', title: 'Задание 7 — Три корзины / Three Baskets',
      prompt: 'Разложи 5 карточек в 3 корзины:\n1. можно доверять;\n2. нужно проверить;\n3. не использовать.\n\nКарточки:\n— школьный сайт с датой;\n— видео без автора;\n— книга с автором;\n— AI-ответ без источника;\n— старая страница 2010 года.',
      ruPrimaryText: 'Классифицируй 5 карточек в 3 корзины.',
      enHelpText: 'Sort 5 cards into 3 baskets.',
      answer: 'Доверять: школьный сайт с датой, книга с автором. Проверить: старая страница 2010, AI-ответ без источника. Не использовать: видео без автора (или AI-ответ, если нельзя проверить).' },
    { id: 'spelling-day2', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\nисточник\nавтор\nдата\nправда\nпроверить\n\nВставь буквы:\nис_очник\nа_тор\nд_та\nпр_вда\nпров_рить',
      ruPrimaryText: 'Напиши 5 слов и вставь буквы.',
      enHelpText: 'Write 5 words and fill in letters.',
      answer: 'источник, автор, дата, правда, проверить.' },
    { id: 'creative-my-source-card', type: 'text', title: 'Задание 9 — Моя карточка источника / My Source Card',
      prompt: 'Нарисуй карточку-проект: выдуманную книгу с автором и датой. Напиши 2 предложения: почему этому источнику можно доверять.',
      ruPrimaryText: 'Нарисуй карточку источника с автором/датой и 2 предложения.',
      enHelpText: 'Draw a source card with author and date; write 2 sentences.',
      answer: 'Open-ended. Карточка + 2 фразы.' },
    { id: 'speech-day2', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\nНадёжный источник имеет автора.\nДата помогает понять, старый или новый.\nДоказательство помогает поверить.',
      ruPrimaryText: 'Объясни автора, дату и доказательство по-русски.',
      enHelpText: 'Tell the parent about author, date and evidence.',
      answer: 'Accept if Anita explains in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Начерти таблицу источников и 3 корзины.',
    '2. Реши задачи 3–6.',
    '3. Разложи карточки в корзины.',
    '4. Напиши 5 слов и объясни родителю.'
  ],
  printWorksheet: {
    title: 'Надёжный источник / Reliable Source',
    subtitle: 'Неделя 5 · День 2 / Week 5 · Day 2',
    pages: [
      {
        title: 'Маршрут и математика / Route and Math',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: сегодня ты учишься отличать надёжный источник по автору, дате и доказательству.' },
          { type: 'text', text: 'Задание 1 — Слова источника. Прочитай и обведи:' },
          { type: 'list', items: ['источник / source', 'автор / author', 'дата / date', 'правда / truth', 'проверить / to check'] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
          { type: 'list', items: ['□ Автор говорит, кто это написал.', '□ Дата говорит, когда это написано.', '□ Доказательство помогает поверить.', '□ Если этого нет — источник не самый надёжный.'] },
          { type: 'text', text: 'Задание 3 — Баллы источника. Баллы: автор — 3, дата — 2, доказательство — 4.' },
          { type: 'list', items: [
            'Источник | Автор (3) | Дата (2) | Доказательство (4) | Всего',
            '   A     |    ✓      |          |         ✓         | 3 + 4 = ___',
            '   B     |           |    ✓     |         ✓         | 2 + 4 = ___',
            'Разница A − B = ___'
          ] }
        ]
      },
      {
        title: 'Дроби, время и корзины / Fractions, Time, Baskets',
        blocks: [
          { type: 'text', text: 'Задание 4 — Проверка 48 источников. Готовая таблица:' },
          { type: 'list', items: [
            'Всего источников           | 48',
            'Старые (1/4)               | 48 ÷ 4 = ___',
            'Полезные (1/3)             | 48 ÷ 3 = ___',
            'Проверить ещё раз          | 48 − ___ − ___ = ___'
          ] },
          { type: 'text', text: 'Задание 5 — Время проверки:' },
          { type: 'list', items: ['5 × 7 = ___ минут', '___ + 10 = ___ минут всего'] },
          { type: 'text', text: 'Задание 6 — Средний рейтинг: 6, 8, 7, 9.' },
          { type: 'list', items: ['Сумма = 6 + 8 + 7 + 9 = ___', 'Средний = ___ ÷ 4 = ___'] },
          { type: 'text', text: 'Задание 7 — Три корзины. Разложи карточки:' },
          { type: 'list', items: [
            'КОРЗИНА 1 — можно доверять:  [ ]  [ ]  [ ]  [ ]',
            'КОРЗИНА 2 — нужно проверить: [ ]  [ ]  [ ]  [ ]',
            'КОРЗИНА 3 — не использовать: [ ]  [ ]  [ ]  [ ]',
            '',
            'Карточки:',
            '□ школьный сайт с датой',
            '□ видео без автора',
            '□ книга с автором',
            '□ AI-ответ без источника',
            '□ старая страница 2010 года'
          ] }
        ]
      },
      {
        title: 'Русский, проект и защита / Russian, Project, Defense',
        blocks: [
          { type: 'text', text: 'Задание 8 — Правописание:' },
          { type: 'list', items: ['источник   автор   дата   правда   проверить', 'ис_очник    а_тор    д_та    пр_вда    пров_рить'] },
          { type: 'text', text: 'Задание 9 — Моя карточка источника. Нарисуй карточку выдуманной книги с автором и датой + 2 предложения:' },
          { type: 'list', items: ['Название: __________________________', 'Автор: __________________________', 'Дата: __________________________', 'Почему можно доверять: 1) __________________________________________', '                       2) __________________________________________'] },
          { type: 'text', text: 'Задание 10 — Объясни родителю:' },
          { type: 'list', items: ['□ Надёжный источник имеет автора.', '□ Дата помогает понять, старый или новый.', '□ Доказательство помогает поверить.'] },
          { type: 'text', text: 'Parent Check: □ слова  □ 5 фраз  □ баллы A и B  □ 1/4 и 1/3 от 48  □ время проверки  □ средний рейтинг  □ 3 корзины  □ карточка источника  □ объяснила.' },
          { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицу баллов и 3 корзины в тетради.' }
        ]
      }
    ]
  },
  parentGuide: {
    whatThisLessonTeaches: 'Оценка надёжности источника по автору, дате и доказательству.',
    howToExplain: 'Скажите: спрашивай кто, когда и чем подтверждают.',
    exampleDialogue: 'Parent: Баллы A?\nChild: 7.\nParent: Баллы B?\nChild: 6.\nParent: Разница?\nChild: 1.',
    readingSupport: 'Слово «доказательство» — по слогам.',
    russianSpeechGoal: 'Анита говорит: «Надёжный источник имеет автора.»',
    spellingCheck: 'Проверить: источник, автор, дата, правда, проверить.',
    readingCheck: 'Попытка русского чтения 4 фраз.',
    practicalCheck: 'Правильное распределение 5 карточек в 3 корзины.',
    discussionPrompts: ['Что важнее: автор, дата или доказательство?', 'Что делает источник «нужно проверить»?'],
    ifEasy: 'Добавить ещё карточку и распределить.',
    ifDifficult: 'Оставить только 2 корзины: доверять/не доверять.',
    commonMistakes: ['«Дата не важна.» Правильно: важна.', '«Красивый сайт = надёжный.» Правильно: смотри автора и доказательство.'],
    drawingCriteria: 'Карточка выдуманного источника с автором и датой.',
    goal: 'Анита оценивает надёжность источников и раскладывает карточки в 3 корзины.',
    mathGoal: 'U.S. Grade 3: сумма баллов + сравнение; 1/3 и 1/4 от 48; × времени + отдых; сумма 4 чисел ÷ 4.',
    russianGoal: 'Прочитать 5 слов и 4 фразы; написать 5 слов и вставить буквы.',
    readingWritingGoal: '2 предложения про свою карточку источника.',
    practicalGoal: 'Правильно распределить 5 карточек в 3 корзины.',
    parentTheoryCard: {
      title: 'Как проверить источник',
      purpose: 'Показать 3 критерия надёжного источника.',
      keyMessage: 'Автор + Дата + Доказательство = надёжный источник.',
      parentScript: [
        '«Автор — кто это сказал?»',
        '«Дата — когда это сказано?»',
        '«Доказательство — можно ли проверить?»',
        '«1/4 от 48 = 12; 1/3 от 48 = 16.»'
      ],
      practiceSteps: ['Заполните таблицу баллов.', 'Найдите 1/4 и 1/3 от 48.', 'Разложите 5 карточек в 3 корзины.'],
      paperOnlyNotes: ['Все задания на бумаге.', 'Никаких настоящих переходов по сайтам.'],
      doNotSay: ['Не решай задачи за Аниту.', 'Не давай готовое распределение карточек без обсуждения.']
    },
    keyMessage: 'Точный вопрос, надёжный источник, факт с доказательством, проверка ИИ, опыт про плотность.',
    check: ['Анита сравнила A и B.', 'Анита нашла 1/3 и 1/4 от 48.', 'Анита разложила 5 карточек в 3 корзины.'],
    mathAnswerKey:
      'math-source-score: A = 3 + 4 = 7; B = 2 + 4 = 6; A больше на 7 − 6 = 1.\n' +
      'math-check-48: 48 ÷ 4 = 12; 48 ÷ 3 = 16; 48 − 12 − 16 = 20.\n' +
      'math-time-check: 5 × 7 = 35; 35 + 10 = 45 минут.\n' +
      'math-avg-rating: 6 + 8 + 7 + 9 = 30; 30 ÷ 4 = 7.5.',
    spellingAnswerKey: 'источник\nавтор\nдата\nправда\nпроверить',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения 5 слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения 4 фраз.' },
      { taskId: 'math-source-score', answer: 'A = 7; B = 6; разница 1.' },
      { taskId: 'math-check-48', answer: '12; 16; 20.' },
      { taskId: 'math-time-check', answer: '35; 45.' },
      { taskId: 'math-avg-rating', answer: '30; 7.5.' },
      { taskId: 'logic-classify-sources', answer: 'Доверять: сайт с датой, книга. Проверить: старая страница, AI без источника. Не использовать: видео без автора.' },
      { taskId: 'spelling-day2', answer: '5 слов.' },
      { taskId: 'creative-my-source-card', answer: 'Карточка + 2 фразы.' },
      { taskId: 'speech-day2', answer: 'Идея по-русски.' }
    ],
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за 3 корзины.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Никаких настоящих сайтов не открывайте в этом задании. Всё — на бумаге.',
    safetyNotes: 'Все источники в задании — выдуманные примеры на бумаге. Никаких настоящих переходов по ссылкам с ребёнком.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима', bonuses: [
    { id: 'clear-baskets', label: 'Бонус за 3 корзины', amount: 1 }
  ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'math-source-score', 'math-check-48', 'math-time-check', 'math-avg-rating', 'logic-classify-sources', 'spelling-day2', 'creative-my-source-card', 'speech-day2'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-5-day-3'
};

export default day2;
